import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 10",
  height: "48",
  width: "48",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.122,5.523,9.805,1.84a.666.666,0,0,0,0-.94L9.1.2a.664.664,0,0,0-.94,0L4.477,3.877a.5.5,0,0,0-.139.267L4.062,5.705a.2.2,0,0,0,.2.235.2.2,0,0,0,.034,0l1.561-.276A.5.5,0,0,0,6.122,5.523Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.829,6.23a1.5,1.5,0,0,1-.8.416l-1.563.276a1.433,1.433,0,0,1-.206.018,1.19,1.19,0,0,1-.849-.352,1.2,1.2,0,0,1-.334-1.057l.276-1.562a1.494,1.494,0,0,1,.417-.8L5.513,1.427A.25.25,0,0,0,5.336,1H1.5A1.5,1.5,0,0,0,0,2.5l.01,6a1.5,1.5,0,0,0,1.5,1.5H7.5A1.5,1.5,0,0,0,9,8.5V4.663a.25.25,0,0,0-.427-.177Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1)
  ])))
}
export default { render: render }